import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.showPanel("slots")
  }

  switch(event) {
    const panel = event.currentTarget.dataset.panel
    this.showPanel(panel)
  }

  showPanel(active) {
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.panel === active
      tab.classList.toggle("active-tab", isActive)
      tab.classList.toggle("inactive-tab", !isActive)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.panel !== active)
    })

    // toggle view-all links
    const slotsLink = this.element.querySelector("#tab-slots-link")
    const newsLink  = this.element.querySelector("#tab-news-link")
    if (slotsLink) slotsLink.classList.toggle("hidden", active !== "slots")
    if (newsLink)  newsLink.classList.toggle("hidden",  active !== "news")
  }
}
